<template>
    <div class="network-invite">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        {{model.email}}
                        <span v-if="model.inviteable.enrolledLabel" v-html="model.inviteable.enrolledLabel"></span>
                        <span v-if="model.statusLabel" v-html="model.statusLabel"></span>
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Grant Network Access</h4>

                    <h5 v-if="model.created_at">Network Access</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="row" v-if="model.created_at">
                    <div class="col-sm-6 form-group">
                        <dl class="no-margin">
                            <dt>Building</dt>
                            <dd>{{model.building}}</dd>

                            <dt>Floor</dt>
                            <dd>{{model.floor}}</dd>

                            <dt>Unit</dt>
                            <dd>{{model.unit}}</dd>
                        </dl>
                    </div>

                    <div class="col-sm-6 form-group">
                        <dl class="no-margin">
                            <dt>Start At</dt>
                            <dd>{{model.start_at}}</dd>

                            <dt>End At</dt>
                            <dd>{{model.end_at}}</dd>
                        </dl>
                    </div>
                </div>

                <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                      data-vv-scope="networkInvite">
                    <fieldset>
                        <legend>Network Access</legend>

                        <div class="form-group has-feedback"
                             v-if="!model.created_at && !model.deleted_at"
                             :class="{'has-error': errors.has('networkInvite.NetworkInvite[email]')}">
                            <label for="network-invite-email">Email</label>
                            <input id="network-invite-email"
                                   autocomplete="off"
                                   v-validate="'required'"
                                   v-model="model.email"
                                   required="required"
                                   name="NetworkInvite[email]"
                                   type="email"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('networkInvite.NetworkInvite[email]')" class="help-block">
                                {{ errors.first('networkInvite.NetworkInvite[email]') }}
                            </span>
                        </div>

                        <div class="row" v-if="!model.deleted_at">
                            <div class="col-sm-6 form-group has-feedback"
                                 v-if="!model.created_at"
                                 :class="{'has-error': errors.has('networkInvite.NetworkInvite[start_at]')}">
                                <label for="network-invite-start-at">Start At</label>

                                <input id="network-invite-start-at"
                                       name="NetworkInvite[start_at]"
                                       type="date"
                                       class="form-control"
                                       required="required"
                                       v-model="model.start_at">

                                <span v-show="errors.has('networkInvite.NetworkInvite[start_at]')" class="help-block">
                                    {{ errors.first('networkInvite.NetworkInvite[start_at]') }}
                                </span>
                            </div>

                            <div class="col-sm-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('networkInvite.NetworkInvite[end_at]')}">
                                <label for="network-invite-end-at">End At</label>

                                <input id="network-invite-end-at"
                                       name="NetworkInvite[end_at]"
                                       type="date"
                                       class="form-control"
                                       v-model="model.end_at">

                                <span v-show="errors.has('networkInvite.NetworkInvite[end_at]')" class="help-block">
                                    {{ errors.first('networkInvite.NetworkInvite[end_at]') }}
                                </span>
                            </div>
                        </div>

                        <div class="row" v-if="!model.deleted_at">
                            <div class="col-sm-4 has-feedback"
                                 :class="{'has-error': errors.has('networkInvite.NetworkInvite[building]')}">
                                <label for="network-invite-building">Building</label>

                                <select id="network-invite-building"
                                        v-validate="'required'"
                                        v-model="model.building"
                                        name="NetworkInvite[building]"
                                        class="form-control"
                                        aria-required="true">
                                    <option value="">-</option>
                                    <option v-for="building in buildings" :value="building">
                                        {{building}}
                                    </option>
                                </select>

                                <span v-show="errors.has('networkInvite.NetworkInvite[building]')" class="help-block">
                                    {{ errors.first('networkInvite.NetworkInvite[building]') }}
                                </span>
                            </div>

                            <div class="col-sm-4 has-feedback"
                                 :class="{'has-error': errors.has('networkInvite.NetworkInvite[floor]')}">
                                <label for="network-invite-floor">Floor</label>

                                <select id="network-invite-floor"
                                        v-validate="'required'"
                                        v-model="model.floor"
                                        name="NetworkInvite[floor]"
                                        class="form-control"
                                        :disabled="!model.building"
                                        aria-required="true">
                                    <option value="">-</option>
                                    <option v-for="floor in floors" :value="floor">
                                        {{floor}}
                                    </option>
                                </select>

                                <span v-show="errors.has('networkInvite.NetworkInvite[floor]')" class="help-block">
                                    {{ errors.first('networkInvite.NetworkInvite[floor]') }}
                                </span>
                            </div>

                            <div class="col-sm-4 has-feedback"
                                 :class="{'has-error': errors.has('networkInvite.NetworkInvite[unit]')}">
                                <label for="network-invite-unit">Unit</label>

                                <select id="network-invite-unit"
                                        v-validate="'required'"
                                        v-model="model.unit"
                                        name="NetworkInvite[unit]"
                                        class="form-control"
                                        :disabled="!model.building || !model.floor"
                                        aria-required="true">
                                    <option value="">-</option>
                                    <option v-for="unit in units" :value="unit">
                                        {{unit}}
                                    </option>
                                </select>

                                <span v-show="errors.has('networkInvite.NetworkInvite[unit]')" class="help-block">
                                    {{ errors.first('networkInvite.NetworkInvite[unit]') }}
                                </span>
                            </div>
                        </div>

                        <hr v-if="!model.deleted_at">

                        <div class="row">
                            <div class="col-xs-6">
                                <button type="button" class="btn btn-sm btn-warning"
                                        @click="deleteModel"
                                        v-if="model.created_at && !model.deleted_at"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>

                                <button type="button" class="btn btn-sm btn-warning"
                                        @click="restoreModel"
                                        v-if="model.created_at && model.deleted_at"
                                        :disabled="loading">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-6 form-group pull-right" v-if="!model.deleted_at">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            inviteableType: {
                required: true,
                type: String
            },

            inviteableId: {
                required: true,
                type: String
            },

            projectId: {
                required: true,
                type: String
            },
        },

        computed: {
            buildings(){
                if( this.projectIntegration.created_at ){
                    return _.uniq( _.map( this.projectIntegration.credentialOptions, 'Building' ) ).sort();
                }

                return [];
            },

            floors(){
                if( this.projectIntegration.created_at && this.model.building ){
                    return _.uniq(
                        _.map(
                            _.filter( this.projectIntegration.credentialOptions, ( credentialOption ) => {
                                return credentialOption.Building === this.model.building;
                            } ),
                            'Floor'
                        )
                    ).sort();
                }

                return [];
            },

            units(){
                if( this.projectIntegration.created_at && this.model.building && this.model.floor ){
                    return _.uniq(
                        _.map(
                            _.filter( this.projectIntegration.credentialOptions, ( credentialOption ) => {
                                return credentialOption.Building === this.model.building &&
                                    credentialOption.Floor === this.model.floor;
                            } ),
                            'Unit'
                        )
                    ).sort();
                }

                return [];
            },

            saveValidationKey(){
                return 'networkInvite'
            },

            resourceKey(){
                return 'NetworkInvite';
            },

            url(){
                if( this.model.id ){
                    return '/api/networkInvites/' + this.model.id;
                }
                else {
                    return '/api/networkInvites';
                }
            },
        },

        watch: {
            'model.building'(){
                // if ( this.model.floor !== null && this.model.floor ) {
                //
                // }
            },

            'model.floor'(){
            },
        },

        methods: {
            beforeLoad(){
                return Promise.all( [
                    this.loadInviteable(),
                    this.loadProjectIntegration(),
                ] );
            },

            afterLoad(){
                if( !this.model.created_at ){
                    this.setFields();
                }
            },

            beforeSave(){
                this.model.project_id = this.projectId;
                this.model.inviteable_id = this.inviteableId;
                this.model.inviteable_type = this.inviteableType;
            },

            getModelData(){
                return {
                    model: {
                        start_at: moment().format( 'YYYY-MM-DD' )
                    },
                    inviteable: {},
                    projectIntegration: {},
                };
            },

            loadInviteable(){
                let url = '/api/residents/' + this.inviteableId;

                if( this.inviteableType === 'App\\User' ){
                    url = '/api/users/' + this.inviteableId + '?_load[]=address';
                }

                return axios.get( url )
                    .then( ( response ) => {
                        let inviteable = null;

                        if( this.inviteableType === 'App\\Resident' ){
                            inviteable = response.data.Resident;
                        }
                        else if( this.inviteableType === 'App\\User' ){
                            inviteable = response.data.User;
                        }

                        this.$set( this, 'inviteable', inviteable );
                    } );
            },

            loadProjectIntegration(){
                var url = '/api/projectIntegrations?_load[]=credentialOptions&limit=1&type=0&project_id=' + this.projectId;

                return axios.get( url )
                    .then( ( response ) => {
                        let projectIntegration = _.head( response.data.ProjectIntegrations );

                        if( !projectIntegration ){
                            throw new Error( 'No ProjectIntegration found' );
                        }

                        this.$set( this, 'projectIntegration', projectIntegration );
                    } );
            },

            setFields(){
                let option = null;
                if( this.inviteableType === 'App\\Resident' && this.inviteable.unit ){
                    option = _.find( this.projectIntegration.credentialOptions, { 'Unit': this.inviteable.unit } );

                    if( !option ){
                        option = _.find( this.projectIntegration.credentialOptions, { 'Unit': _.trimStart( this.inviteable.unit, '0' ) } );
                    }

                    // Disable until Lease.move_out_at
                    // if( this.inviteable.lease && this.inviteable.lease.end_at ){
                    //     this.$set( this.model, 'end_at', moment.utc( this.inviteable.lease.end_at ).format( 'YYYY-MM-DD' ) );
                    // }
                    // else if( this.inviteable.move_out_at ){
                    //     this.$set( this.model, 'end_at', moment.utc( this.inviteable.move_out_at ).format( 'YYYY-MM-DD' ) );
                    // }
                }
                else if( this.inviteableType === 'App\\User' && this.inviteable.address && this.inviteable.address.address_2 ){
                    option = _.find( this.projectIntegration.credentialOptions, { 'Unit': this.inviteable.address.address_2 } );

                    if( !option ){
                        option = _.find( this.projectIntegration.credentialOptions, { 'Unit': _.trimStart( this.inviteable.address.address_2, '0' ) } );
                    }
                }

                if( option ){
                    this.$set( this.model, 'building', option.Building );
                    this.$set( this.model, 'floor', option.Floor );
                    this.$set( this.model, 'unit', option.Unit );
                }

                if( this.inviteable.contactEmail ){
                    this.$set( this.model, 'email', this.inviteable.contactEmail );
                }
            },

            setModel( response ){
                let networkInvite = response.data[ this.resourceKey ];

                networkInvite.start_at = moment.utc( networkInvite.start_at ).format( 'YYYY-MM-DD' );
                if( networkInvite.end_at ){
                    networkInvite.end_at = moment.utc( networkInvite.end_at ).format( 'YYYY-MM-DD' );
                }

                return this.$set( this, 'model', networkInvite );
            },
        }
    }
</script>
